import { render } from "./MarketStrip.vue?vue&type=template&id=9f30a55e&scoped=true"
import script from "./MarketStrip.vue?vue&type=script&lang=js"
export * from "./MarketStrip.vue?vue&type=script&lang=js"

import "./MarketStrip.vue?vue&type=style&index=0&id=9f30a55e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f30a55e"]])

export default __exports__